import { AlertTriangle, ArrowRight, Bot, CheckCircle2, Clock3, ShieldCheck } from "lucide-react";
import { useState } from "react";
import type { Subject, TaskSummary } from "../api.js";
import { AccountMenu } from "../components/AccountMenu.js";
import { BottomNav } from "../components/BottomNav.js";
import { TaskCard } from "../components/TaskCard.js";
import { taskMatchesFilter } from "../task-presentation.js";

export function HomePage({
  subject,
  tasks,
  onLogout = async () => undefined,
}: {
  subject: Subject;
  tasks: TaskSummary[];
  onLogout?: () => Promise<void>;
}) {
  const [mine, setMine] = useState(false);
  const visible = mine
    ? tasks.filter((task) => task.submitterSubjectId === subject.subjectId)
    : tasks;
  const counts = {
    waiting: visible.filter((task) => taskMatchesFilter(task.status, "waiting")).length,
    active: visible.filter((task) => taskMatchesFilter(task.status, "active")).length,
    done: visible.filter((task) => taskMatchesFilter(task.status, "done")).length,
    attention: visible.filter((task) => taskMatchesFilter(task.status, "attention")).length,
  };
  return (
    <div className="app-shell">
      <header className="mobile-header">
        <div>
          <p className="eyebrow">MK · AI WORKBENCH</p>
          <h1>你好，{subject.displayName}</h1>
        </div>
        <AccountMenu subject={subject} onLogout={onLogout} />
      </header>
      <main className="page-content">
        <section className="agent-hero">
          <div className="agent-icon">
            <Bot aria-hidden="true" />
          </div>
          <div>
            <p className="eyebrow">首个部门 Agent</p>
            <h2>MK开发助手</h2>
            <p>上传资料，先整理、再确认、后执行。</p>
          </div>
          <a className="round-link" href="/submit" aria-label="打开MK开发助手">
            <ArrowRight />
          </a>
        </section>
        <section className="metric-grid" aria-label="任务概览">
          <a href="/tasks?filter=waiting">
            <Clock3 />
            <span>等待确认</span>
            <strong>{counts.waiting}</strong>
          </a>
          <a href="/tasks?filter=active">
            <ShieldCheck />
            <span>进行中</span>
            <strong>{counts.active}</strong>
          </a>
          <a href="/tasks?filter=done">
            <CheckCircle2 />
            <span>已完成</span>
            <strong>{counts.done}</strong>
          </a>
          <a href="/tasks?filter=attention">
            <AlertTriangle />
            <span>需处理</span>
            <strong>{counts.attention}</strong>
          </a>
        </section>
        <section className="section-block">
          <div className="section-heading">
            <div>
              <p className="eyebrow">COMPANY TASKS</p>
              <h2>最近任务</h2>
            </div>
            <button
              className={mine ? "filter-chip active" : "filter-chip"}
              onClick={() => setMine(!mine)}
            >
              {mine ? "查看全部" : "只看我的"}
            </button>
          </div>
          <div className="task-list">
            {visible.length ? (
              visible.map((task) => <TaskCard task={task} key={task.taskId} />)
            ) : (
              <div className="empty-card">还没有任务，从“提交”开始。</div>
            )}
          </div>
        </section>
      </main>
      <BottomNav active="home" />
    </div>
  );
}
